export enum FuelDistributionMode {
    AVG, PRIORITY
}
